import { defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    MainPictureCaption: {
        id: 'Profile.Components.Header.MainPictureCaption',
        defaultMessage: `{count} {count, plural,
            one {photo}
            other {photos}
        }`,
    },
    ReadReviewsLink: {
        id: 'Profile.Components.Header.ReadReviewsLink',
        defaultMessage: 'read reviews',
    },
    ReviewsCount: {
        id: 'Profile.Components.Header.ReviewsCount',
        defaultMessage: `{numberOfReviews} {numberOfReviews, plural,
            =1 {review}
            other {reviews}
        }`,
    },

});
